import modalTemplate from './confirm.html'

class Util {
  constructor (Ramda, $mdDialog) {
    const curry = Ramda.curry

    function setDate (date) {
      if (date) return /^\d\d\/\d\d\/\d\d$/.test(date) ? date : moment.utc(date).format('l')
      return 'NA'
    }

    function unique (list) {
      return typeof list === 'string' ? [...new Set(list.split(','))] : [...new Set(list)]
    }

    function objHas (obj, prop) {
      return Reflect.has(obj, prop)
    }

    const confirm = curry((message, event, successfulEvent) => {
      $mdDialog.show({
        controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
          angular.extend(this, {
            message: message,
            event: event,
            successfulEvent: successfulEvent,
            close: () => $mdDialog.hide()
          })
        }],
        controllerAs: 'vm',
        template: modalTemplate,
        clickOutsideToClose: false
      })
    })

    return {
      setDate: setDate,
      unique: unique,
      objHas: objHas,
      confirm: confirm
    }
  }
}

Util.$inject = ['Ramda', '$mdDialog']
export default angular.module('services.Util', []).service('Util', Util).name



// WEBPACK FOOTER //
// ./src/app/u-faculty/lib/util.js